import { ConversionUtil } from "@mcleod/core";

import { LMEGeneralSettings } from "@mcleod/general";
import { AutogenModelPayrollControl, AutogenRowPayrollControl, RowPayrollControlFields } from "./autogen/AutogenModelPayrollControl";

export class ModelPayrollControl extends AutogenModelPayrollControl<RowPayrollControl> {
    constructor() {
        super(RowPayrollControl);
    }
}

export function getPayrollControlBoolean(field: keyof RowPayrollControlFields, valueIfNull: boolean = false): boolean {
    const result = getPayrollControlValue(field);
    if (typeof result === "string")
        return ConversionUtil.parseBoolean(result);
    return result ?? valueIfNull;
}

export function getPayrollControlValue(field: keyof RowPayrollControlFields): any {
    return LMEGeneralSettings.getSingleton().getPayrollControl()[field];
}


export class RowPayrollControl extends AutogenRowPayrollControl {
}